<template>
  <div class="order-dialog" @contextmenu.stop>
    <el-dialog
      title="订单信息"
      width="500px"
      height="600px"
      top="50px"
      custom-class="order-dialog"
      center
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :handleCancel="handleCancel"
    >
      <div class="export-btn" v-if="currentModule !== 'cloud_read_baozhi'" @click="exportOrder()">
        <img src="@imgs/export-icon.png" />
        <span>导出订单记录</span>
      </div>
      <List class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
        <template v-slot:listContent>
          <div class="paper-list-content">
            <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
              <el-table-column prop="orderCode" label="订单号" min-width="100"></el-table-column>
              <el-table-column prop="memberId" label="下单账号" min-width="50"></el-table-column>
              <el-table-column prop="date" label="下单时间" min-width="50"></el-table-column>
            </el-table>
          </div>
        </template>
      </List>
    </el-dialog>
  </div>
</template>

<script>
import List from '@components/list/listFrame'
import chargeManager from '../../../api/chargeManager'
import moment from 'moment'

export default {
  name: 'OrderList',
  data() {
    return {
      dialogVisible: false,
      totalCount: 0,
      currentPageNo: 1,
      tableData: []
    }
  },
  components: {
    List
  },
  props: {
    currentModule: String,
    goodsObj: Object
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getOrderList()
      }
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    flipPage(val) {
      this.currentPageNo = val
      this.getOrderList()
    },
    exportOrder() {
      this.$emit('exportOrder', this.currentModule, this.goodsObj.id)
    },
    getOrderList() {
      let param = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        worksType: this.currentModule,
        worksId: this.goodsObj.worksId
      }
      chargeManager.getOrderPage(param).then((res) => {
        if (res.data.data) {
          let data = res.data.data.page
          this.tableData = data.result.map((item) => {
            let memberId = item.memberId
            if (memberId.length > 5 && memberId.length <= 8) {
              memberId = memberId.substring(0, 3) + '*****'
            } else if (memberId.length > 8) {
              memberId = memberId.substring(0, 3) + '*****' + memberId.substring(8)
            }
            return {
              ...item,
              memberId: memberId,
              date: moment(item.createTime).format('YYYY-MM-DD')
            }
          })
          this.totalCount = data.totalCount
        } else {
          this.tableData = []
          this.totalCount = 0
        }
      })
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-dialog {
  .export-btn {
    width: 120px;
    font-size: 14px;
    color: #df5813;
    font-weight: 400;
    cursor: pointer;
    margin: 5px 0 0 auto;
    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
